import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";

const Settings = () => {
  const breadcrumbs = [
    { title: "Dashboard", url: "/admin/dashboard" },
    { title: "Notifications", url: "" },
  ];

  const SECTIONS = [
    { key: "push", label: "Push Notifications", path: "/admin/notifications/push" },
    { key: "in-app", label: "In App Notifications", path: "/admin/notifications/in-app" },
    { key: "campaigns", label: "Campaigns", path: "/admin/notifications/campaigns" },
  ];

  return (
    <>
      <Breadcrums data={breadcrumbs} />

      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">

            {/* Header  */}
             <div className="d-flex mb-4 border-bottom pb-2">
                {SECTIONS.map((section) => (
                    <NavLink
                    key={section.key}
                    to={section.path}
                    end
                    className={({ isActive }) =>
                        `btn mr-2 nav-link ${
                        isActive ? "active" : ""
                        }`
                    }
                    >
                    {section.label}
                    </NavLink>
                ))}
            </div>

              {/* Child Route Content */}
              <div className="mt-3">
                <Outlet />
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
